__turbopack_context__.v({
  "root": "index-module__U1VIOW__root",
});
